<template>
    <div v-if="knumber == 6" v-loading.fullscreen.lock="loading" :element-loading-text="$t('connecting')"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="page__card">
            <div class="page__card-title">
                <button class="bg-indigo-400 p-1 w-8 h-8 mr-2 rounded-xl" @click="$router.go(-1)">
                    <i class="el-icon-arrow-left"></i>
                </button>
        <h1 ><span v-if=" $route.params.edit" class="bg-indigo-50 py-1 px-3 rounded-lg text-indigo-800">{{ spec1.name_cyr }}</span> 
        {{ $route.params.edit ? $route.params.edit == '0' ? ` - ${$t('building_data')}` :
            ` - ${$t('change_building_data')}` : $t('add_new_building')}}</h1>
        </div>
        <div class="flex flex-wrap gap-5">
            <div v-if=" ['admin', 'org_admin', 'ministry_admin', 'main_org_admin'].includes(role)" class="w-max p-3 rounded-xl bg-gray-100 flex flex-wrap items-center gap-2">
                <el-popover placement="bottom" width="310" v-model="visibleNew" v-if="spec1.status !== 'new'">
                    <p class="mb-3">{{ $t('unattested_approve_warn') }}</p>
                    <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="visibleNew = false">{{ $t('cancel') }}</el-button>
                        <el-button type="primary" size="mini" @click="setStatusToNew(spec1.id)">{{ $t('new_btn')}}</el-button>
                    </div>
                    <button slot="reference" type="button" class="bg-blue-500 text-white font-bold px-4 py-2 rounded-xl flex items-center gap-2">{{ $t('new_btn')}} <h-reload/> </button>
                </el-popover>
                <el-popover v-if="spec1.status !== 'rejected'" placement="bottom" width="310" v-model="visibleReject">
                    <p class="mb-3">{{ $t('unattested_reject_warn') }}</p>
                    <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="visibleReject = false">{{ $t('cancel') }}</el-button>
                        <el-button type="primary" size="mini" @click="reject_info.id = spec1.id; reject_info.modal = true">{{$t('reject_btn') }}</el-button>
                    </div>
                    <button slot="reference" class=" bg-rose-50 text-rose-600 font-bold px-4 py-2 rounded-xl flex items-center gap-2">{{ $t('reject_btn') }} <h-remove-circle/> </button>
                </el-popover>
                <el-popover placement="bottom" width="310" v-model="visibleApprove">
                    <p class="mb-3">{{ $t('unattested_approve_warn') }}</p>
                    <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="visibleApprove = false">{{ $t('cancel') }}</el-button>
                        <el-button type="primary" size="mini" @click="setStatus('approved', spec1.id)">{{ $t('approve_btn')}}</el-button>
                    </div>
                    <button slot="reference" type="button" class="bg-green-500 text-white font-bold px-4 py-2 rounded-xl flex items-center gap-2">{{ $t('approve_btn')}} <h-check-circle/> </button>
                </el-popover>
            </div>
            <div v-if="disabled" class="p-2 pl-4 rounded-2xl bg-cool-50 flex flex-wrap items-center gap-2 flex-1">
                <h-sertificate class="text-cyan-600"/>
                <h1 class="text-slate-600 text-xl leading-snug font-bold">{{ $t('reconstructionsecondstep_finalconclusion') }} </h1>
                <div class="flex-1"></div>
                <div  class="flex items-center px-4 py-2 rounded-2xl text-white gap-3" :class="`finalconclusion_${spec1.finalconclusion}`">
                    {{(dictionary.finalconclusion.find(d => d.id === spec1.finalconclusion) || {})[`name_${$i18n.locale}`] }}
                    <div>
                        <h-check-circle  class="w-6 h-6 xl:w-10 xl:h-10" v-if="spec1.finalconclusion==1"/>
                        <h-smile-ellipse class="w-6 h-6 xl:w-10 xl:h-10" v-if="spec1.finalconclusion==2"/>
                        <h-sad-circle class="w-6 h-6 xl:w-10 xl:h-10" v-if="spec1.finalconclusion==3"/>
                        <icon-reconstruction class="w-6 h-6 xl:w-10 xl:h-10" v-if="spec1.finalconclusion==4"/>
                    </div>
                </div>
            </div>
        </div>
            <!-- <div v-if="spec1.description" class="p-2 pl-4 rounded-2xl bg-rose-50 flex items-center gap-2 mb-5">
                <h-remove-01 class="text-rose-600"/>
                <h1 class="text-rose-600 text-xl leading-snug font-bold">{{ $t('unattested_rejected') }} </h1>
                <div class="flex-1"></div>
                <p class="text-rose-600 text-xl leading-snug font-bold">{{ $t('issue') }}:</p>
                <div v-if="finalconclusion_cyr" class="px-2 py-1 rounded-lg text-lg leading-snug font-bold bg-rose-600 text-white">
                    {{ spec1.description || 'Salom' }}
                </div>
            </div>-->
            <el-form :model="spec1" :rules="rules1" ref="spec1" class="Form">
                <div class="-mx-3 sm:mx-0 p-3 sm:p-4 rounded-2xl bg-white sm:bg-cool-50 mt-5">
                    <div class="flex flex-wrap items-center gap-2 mb-5">
                        <div class="flex items-center gap-2">
                            <icon-building-4 class="w-6 h-6 text-cyan-600"/>
                            <h1 class="font-bold text-xl text-slate-950">{{ $t('all_datas') }}</h1>
                        </div>
                        <div class="flex-1"></div>
                        <div class="flex items-center gap-2">
                            <icon-investment-2 class="w-6 h-6 text-cyan-600"/>
                            <h1 class="font-bold text-xl text-slate-400">{{ $t('investment_project') }}:</h1>
                            <icon-investment-3 class="w-6 h-6 text-slate-400"/>
                        </div>
                    </div>
                    <div class="flex flex-wrap -m-1.5">
                        <div class="p-1.5 w-full sm:w-1/2 md:w-1/3">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('cadaster_number') }} </p>
                                <el-form-item class="mb-0" prop="cadastral_number">
                                    <el-input name="cadaster_number" disabled v-model="spec1.cadastral_number"
                                        :placeholder="`${$t('example')}: 10:01:01:01:01:1111:1111:111`"
                                        clearable />
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5 w-full sm:w-1/2 md:w-1/3">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('name') }} </p>
                                <el-form-item class="mb-0" prop="name_cyr">
                                    <el-input name="building_or_name" :disabled="disabled"
                                        v-model="spec1.name_cyr" :placeholder="$t('building_or_name')"
                                        clearable />    
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5 w-full sm:w-1/2 md:w-1/3">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('year_construction') }} </p>
                                <el-form-item class="mb-0" prop="year_construction">
                                    <el-date-picker name="building_or_year_construction"
                                        :disabled="errors.year_construction || disabled" style="width: 100%"
                                        v-model="spec1.year_construction" type="year" value-format="yyyy"
                                        :placeholder="$t('year_construction')"
                                        :picker-options="pickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5  w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('territory') }} </p>
                                <el-form-item class="mb-0" prop="region">
                                    <el-select name="building_or_region" disabled v-model="spec1.region"
                                        :loading="loading" class="w-full" :placeholder="$t('territory')">
                                        <el-option v-for="item in dictionary.region" :key="item.id"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="item.shared_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5  w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('district') }} </p>
                                <el-form-item class="mb-0" prop="district">
                                    <el-select name="building_or_district" disabled v-model="spec1.district"
                                        class="w-full" clearable :placeholder="$t('building_or_district')">
                                        <el-option v-for="item in current_district" :key="item.id"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="item.shared_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5  w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('neighborhood') }} </p>
                                <el-form-item class="mb-0" prop="neigboardhood">
                                    <el-input name="building_or_neoghborhood" v-if="spec1.neighborhood" disabled
                                        v-model="spec1.neighborhood" :placeholder="$t('neighborhood')"
                                        clearable />
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5  w-full lg:w-1/4">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('address') }} </p>
                                <el-form-item class="mb-0" prop="address">
                                    <el-input name="building_or_street" disabled v-model="spec1.address"
                                        :placeholder="$t('building_or_street')" clearable />
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('floor_count') }} </p>
                                <el-form-item class="mb-0" prop="numberfloors">
                                    <el-select name="floor_count" :disabled="disabled" v-model="spec1.numberfloors"
                                        class="w-full" :placeholder="$t('floor_count')" clearable allow-create
                                        filterable>
                                        <el-option v-for="item in 100" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('building_one_category') }} </p>
                                <el-form-item class="mb-0" prop="building_group">
                                    <el-select name="building_one_category" v-model="spec1.building_group"
                                        :disabled="disabled" class="w-full" :placeholder="$t('building_one_category')"
                                        clearable>
                                        <el-option v-for="item in dictionary.buildinggroup" :key="item.id"
                                            :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </label>
                        </div>
                        <div class="p-1.5 w-full lg:w-1/3">
                            <label class="item">
                                <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('geolocation') }} </p>
                                <el-form-item class="mb-0" prop="geolocation">
                                    <div class="flex align-top">
                                        <el-input name="building_or_geo" disabled class="flex-1"
                                            v-model="coor" :placeholder="$t('geolocation')" />
                                        <button type="button" class="w-10 h-10 bg-indigo-50 hover:bg-indigo-100 text-indigo-800 rounded-xl ml-2 flex items-center justify-center"
                                        @click="EditMap(spec1.district)">
                                            <h-eye/>
                                        </button>
                                        <button type="button" v-if="!disabled" class="w-10 h-10 bg-indigo-800 hover:bg-indigo-700 text-white rounded-xl ml-2 flex items-center justify-center"
                                        @click="EditMap(spec1.district)">
                                            <h-edit/>
                                        </button>
                                    </div>
                                </el-form-item>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="sm:p-4 sm:rounded-2xl sm:bg-cool-50 mt-5">
                    <div class="flex items-center gap-2 mb-5">
                        <h-compass class="w-6 h-6 text-cyan-600"/>
                        <h1 class="font-bold text-xl text-slate-950">{{ $t('technical_information') }}</h1>
                        <div class="flex-1"></div>
                    </div>
                    <div class="-mx-3 sm:mx-0 bg-white p-3 sm:p-4" style="border-radius: 20px;">
                        <div class="flex flex-wrap -m-1.5">
                            <div class="p-1.5  w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('transport_seismicity_construction_site') }} </p>
                                    <el-form-item class="mb-0" prop="buildingseismicity">
                                        <el-select name="building_buildingseismicity" :disabled="disabled"
                                            v-model="spec1.buildingseismicity" class="w-full"
                                            :placeholder="$t('building_buildingseismicity')" clearable>
                                            <el-option v-for="item in dictionary.buildingseismicity" :key="item.id"
                                                :label="item.number" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('floors_height') }} </p>
                                    <div class="flex -m-1">
                                        <el-form-item class="p-1 mb-0 w-3/4 2xl:w-4/5" prop="floors_height.value">
                                            <el-input name="floors_height" :disabled="disabled"
                                                :placeholder="$t('floors_height')" type="number"
                                                v-model="spec1.floors_height.value" clearable />
                                        </el-form-item>
                                        <el-form-item class="p-1 mb-0 w-1/4 2xl:w-1/5" prop="floors_height.unit">
                                            <el-select name="floors_height_unit" :disabled="disabled"
                                                v-model="spec1.floors_height.unit" clearable>
                                                <el-option v-for="item in units.unit_1" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('foundation_type') }} </p>
                                    <el-form-item class="mb-0" prop="foundation_type">
                                        <el-select name="foundation_type" :disabled="disabled"
                                            v-model="spec1.foundation_type" class="w-full"
                                            :placeholder="$t('foundation_type')" clearable>
                                            <el-option v-for="item in dictionary.foundationtype"
                                                :key="item.id"
                                                :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('constructive_solution') }} </p>
                                    <el-form-item class="mb-0" prop="constructivesolution">
                                        <el-select name="buildng_constructivesolution" :disabled="disabled"
                                            v-model="spec1.constructivesolution" class="w-full"
                                            :placeholder="$t('buildng_constructivesolution')" clearable>
                                            <el-option v-for="item in dictionary.constructivesolution"
                                                :key="item.id"
                                                :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('part_attic') }} </p>
                                    <div class="flex -m-1">
                                        <el-form-item class="p-1 mb-0 w-3/4 2xl:w-4/5" prop="part_attic.value">
                                            <el-input name="part_attic" :disabled="disabled"
                                                :placeholder="$t('part_attic')" type="number"
                                                v-model="spec1.part_attic.value" clearable />
                                        </el-form-item>
                                        <el-form-item class="p-1 mb-0 w-1/4 2xl:w-1/5" prop="part_attic.unit">
                                            <el-select name="part_attic_unit" :disabled="disabled"
                                                v-model="spec1.part_attic.unit" clearable>
                                                <el-option v-for="item in units.unit_1" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('load_bearing') }} </p>
                                    <el-form-item class="mb-0" prop="load_bearing">
                                        <el-select name="load_bearing" :disabled="disabled"
                                            v-model="spec1.load_bearing" class="w-full" clearable
                                            :placeholder="$t('load_bearing')">
                                            <el-option v-for="item in dictionary.loadbearing" :key="item.id"
                                                :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('plannedshape') }} </p>
                                    <el-form-item class="mb-0" prop="plannedshape">
                                        <el-select name="building_plannedshape" :disabled="disabled"
                                            :placeholder="$t('building_plannedshape')" v-model="spec1.plannedshape"
                                            class="w-full" clearable>
                                            <el-option v-for="item in dictionary.plannedshape" :key="item.id"
                                                :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('technical_height') }} </p>
                                    <div class="flex -m-1">
                                        <el-form-item class="p-1 mb-0 w-3/4 2xl:w-4/5" prop="technical_height.value">
                                            <el-input name="technical_height" :disabled="disabled"
                                                :placeholder="$t('technical_height')" type="number"
                                                v-model="spec1.technical_height.value" clearable />
                                        </el-form-item>
                                        <el-form-item class="p-1 mb-0 w-1/4 2xl:w-1/5" prop="technical_height.unit">
                                            <el-select name="technical_height_unit" :disabled="disabled"
                                                v-model="spec1.technical_height.unit" clearable>
                                                <el-option v-for="item in units.unit_1" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('coverings') }} </p>
                                    <el-form-item class="mb-0" prop="coverings">
                                        <el-select name="coverings" :disabled="disabled"
                                            :placeholder="$t('coverings')" v-model="spec1.coverings"
                                            class="w-full" clearable>
                                            <el-option v-for="item in dictionary.coverings" :key="item.id"
                                                :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('dimensional_parameters') }} </p>
                                    <div class="flex -m-1">
                                        <div class="mb-0 p-1 w-3/4 2xl:w-4/5">
                                            <div class="-m-1 flex">
                                                <el-form-item class="mb-0 p-1 " prop="overall_size.length">
                                                    <el-input name="overall_size_length" type="number"
                                                    :disabled="disabled" v-model="spec1.overall_size.length"
                                                    :placeholder="$t('lengths')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="overall_size.width">
                                                    <el-input name="overall_size_width" type="number"
                                                    :disabled="disabled" v-model="spec1.overall_size.width"
                                                    :placeholder="$t('width')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="overall_size.height">
                                                    <el-input name="overall_size_height" type="number"
                                                    :disabled="disabled" v-model="spec1.overall_size.height"
                                                    :placeholder="$t('height')" clearable />
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <el-form-item class="mb-0 p-1 w-1/4 2xl:w-1/5" prop="overall_size.unit">
                                            <el-select name="overall_size_unit" :disabled="disabled"
                                                v-model="spec1.overall_size.unit" class="w-full" clearable>
                                                <el-option v-for="item in units.unit_1" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('balance_value') }} </p>
                                    <div class="flex -m-1">
                                        <el-form-item class="p-1 mb-0 w-3/4 2xl:w-4/5" prop="balance_value.price">
                                            <el-input name="balance_value_price" :disabled="disabled"
                                                :placeholder="$t('balance_value')" type="number"
                                                v-model="spec1.balance_value.price" clearable />
                                        </el-form-item>
                                        <el-form-item class="p-1 mb-0 w-1/4 2xl:w-1/5" prop="balance_value.currency">
                                            <el-select name="balance_value_currency" :disabled="disabled"
                                                v-model="spec1.balance_value.currency" clearable>
                                                <el-option v-for="item in dictionary.currency" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('roofsection') }} </p>
                                    <el-form-item class="mb-0" prop="roofsection">
                                        <el-select name="roofsection" :disabled="disabled"
                                            :placeholder="$t('roofsection')" v-model="spec1.roofsection"
                                            class="w-full" clearable>
                                            <el-option v-for="item in dictionary.roofsection" :key="item.id"
                                                :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('divided_into_sections_input') }} </p>
                                    <el-form-item class="mb-0" prop="divided_into_sections">
                                        <el-radio id="divided_into_sections" :disabled="disabled"
                                            v-for="(item, i) in dictionary.dividedintosections" :key="i"
                                            v-model="spec1.divided_into_sections" class="prim" :label="item.id"
                                            border>
                                            {{ item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] :
                                            item.name_cyr }}
                                        </el-radio>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('basement_presence') }} </p>
                                    <el-form-item class="mb-0" prop="basement_presence.presence">
                                        <el-radio id="basement_presence" :disabled="disabled"
                                            v-for="(item, i) in dictionary.presence" :key="i"
                                            v-model="spec1.basement_presence.presence" class="prim" :label="item.id"
                                            border>
                                            {{ item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] :
                                            item.name_cyr }}
                                        </el-radio>
                                    </el-form-item>
                                </label>
                            </div>
                            <div v-if="spec1.basement_presence.presence === 1" class="p-1.5 w-full sm:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('basement_merit') }} </p>
                                    <div class="flex -m-1">
                                        <div class="mb-0 p-1 w-3/4 2xl:w-4/5">
                                            <div class="-m-1 flex">
                                                <el-form-item class="mb-0 p-1 " prop="basement_presence.length">
                                                    <el-input name="basement_presence_length" type="number"
                                                    :disabled="disabled" v-model="spec1.basement_presence.length"
                                                    :placeholder="$t('lengths')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="basement_presence.width">
                                                    <el-input name="basement_presence_width" type="number"
                                                    :disabled="disabled" v-model="spec1.basement_presence.width"
                                                    :placeholder="$t('width')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="basement_presence.height">
                                                    <el-input name="basement_presence_height" type="number"
                                                    :disabled="disabled" v-model="spec1.basement_presence.height"
                                                    :placeholder="$t('height')" clearable />
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <el-form-item class="mb-0 p-1 w-1/4 2xl:w-1/5" prop="basement_presence.unit">
                                            <el-select name="basement_presence_unit" :disabled="disabled"
                                                v-model="spec1.basement_presence.unit" class="w-full" clearable>
                                                <el-option v-for="item in units.unit_1" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="-mx-3 sm:mx-0 bg-white p-3 sm:p-4 mt-5" style="border-radius: 20px;">
                        <div class="flex flex-wrap -m-1.5">
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('divisions_number') }} </p>
                                    <el-form-item class="mb-0" prop="divisions_number">
                                        <el-input name="divisions_number" :disabled="disabled"
                                            :placeholder="$t('divisions_number')" type="number"
                                            v-model="spec1.divisions_number" clearable />
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('longitudinal_wall') }} </p>
                                    <el-form-item class="mb-0" prop="longitudinal_wall">
                                        <el-input name="longitudinal_wall" :disabled="disabled"
                                            :placeholder="$t('longitudinal_wall')" type="number"
                                            v-model="spec1.longitudinal_wall" clearable />
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('window_betwee_length') }} </p>
                                    <div class="flex -m-1">
                                        <div class="mb-0 p-1 w-3/4 2xl:w-4/5">
                                            <div class="-m-1 flex">
                                                <el-form-item class="mb-0 p-1 " prop="window_spacing.length">
                                                    <el-input name="window_spacing_length" type="number"
                                                    :disabled="disabled" v-model="spec1.window_spacing.length"
                                                    :placeholder="$t('lengths')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="window_spacing.width">
                                                    <el-input name="window_spacing_width" type="number"
                                                    :disabled="disabled" v-model="spec1.window_spacing.width"
                                                    :placeholder="$t('width')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="window_spacing.height">
                                                    <el-input name="window_spacing_height" type="number"
                                                    :disabled="disabled" v-model="spec1.window_spacing.height"
                                                    :placeholder="$t('height')" clearable />
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <el-form-item class="mb-0 p-1 w-1/4 2xl:w-1/5" prop="window_spacing.unit">
                                            <el-select name="window_spacing_unit" :disabled="disabled"
                                                v-model="spec1.window_spacing.unit" class="w-full" clearable>
                                                <el-option v-for="item in units.unit_1" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('chok_count') }} </p>
                                    <div class="flex -m-1">
                                        <div class="mb-0 p-1 w-3/4 2xl:w-4/5">
                                            <div class="-m-1 flex">
                                                <el-form-item class="mb-0 p-1 " prop="section_parameters.length">
                                                    <el-input name="section_parameters_length" type="number"
                                                    :disabled="disabled" v-model="spec1.section_parameters.length"
                                                    :placeholder="$t('lengths')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="section_parameters.width">
                                                    <el-input name="section_parameters_width" type="number"
                                                    :disabled="disabled" v-model="spec1.section_parameters.width"
                                                    :placeholder="$t('width')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="section_parameters.height">
                                                    <el-input name="section_parameters_height" type="number"
                                                    :disabled="disabled" v-model="spec1.section_parameters.height"
                                                    :placeholder="$t('height')" clearable />
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <el-form-item class="mb-0 p-1 w-1/4 2xl:w-1/5" prop="section_parameters.unit">
                                            <el-select name="section_parameters_unit" :disabled="disabled"
                                                v-model="spec1.section_parameters.unit" class="w-full" clearable>
                                                <el-option v-for="item in units.unit_1" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('longitudinal_wall_spacing') }} </p>
                                    <el-form-item class="mb-0" prop="longitudinal_wall_spacing">
                                        <el-input name="longitudinal_wall_spacing" :disabled="disabled"
                                            :placeholder="$t('longitudinal_wall_spacing')" type="number"
                                            v-model="spec1.longitudinal_wall_spacing" clearable />
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('walls_length') }} </p>
                                    <div class="flex -m-1">
                                        <div class="mb-0 p-1 w-3/4 2xl:w-4/5">
                                            <div class="-m-1 flex">
                                                <el-form-item class="mb-0 p-1 " prop="curtains.length">
                                                    <el-input name="curtains_length" type="number"
                                                    :disabled="disabled" v-model="spec1.curtains.length"
                                                    :placeholder="$t('lengths')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="curtains.width">
                                                    <el-input name="curtains_width" type="number"
                                                    :disabled="disabled" v-model="spec1.curtains.width"
                                                    :placeholder="$t('width')" clearable />
                                                </el-form-item>
                                                <el-form-item class="mb-0 p-1 " prop="curtains.height">
                                                    <el-input name="curtains_height" type="number"
                                                    :disabled="disabled" v-model="spec1.curtains.height"
                                                    :placeholder="$t('height')" clearable />
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <el-form-item class="mb-0 p-1 w-1/4 2xl:w-1/5" prop="curtains.unit">
                                            <el-select name="curtains_unit" :disabled="disabled"
                                                v-model="spec1.curtains.unit" class="w-full" clearable>
                                                <el-option v-for="item in units.unit_1" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('transverse_wall_step') }} </p>
                                    <el-form-item class="mb-0" prop="transverse_wall_step">
                                        <el-input name="transverse_wall_step" :disabled="disabled"
                                            :placeholder="$t('transverse_wall_step')" type="number"
                                            v-model="spec1.transverse_wall_step" clearable />
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('seismicbelts') }} </p>
                                    <el-form-item class="mb-0" prop="seismicbelts">
                                        <el-radio id="seismicbelts" :disabled="disabled"
                                            v-for="(item, i) in dictionary.beltspresence" :key="i"
                                            v-model="spec1.seismicbelts" class="prim" :label="item.id"
                                            border>
                                            {{ item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] :
                                            item.name_cyr }}
                                        </el-radio>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 xl:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('connectingbelts') }} </p>
                                    <el-form-item class="mb-0" prop="connectingbelts">
                                        <el-radio id="connectingbelts" :disabled="disabled"
                                            v-for="(item, i) in dictionary.beltspresence" :key="i"
                                            v-model="spec1.connectingbelts" class="prim" :label="item.id"
                                            border>
                                            {{ item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] :
                                            item.name_cyr }}
                                        </el-radio>
                                    </el-form-item>
                                </label>
                            </div>  
                        </div>
                    </div>
                    <div class="-mx-3 sm:mx-0 bg-white p-3 sm:p-4 mt-5" style="border-radius: 20px;">
                        <div class="flex flex-wrap -m-1.5">
                            <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('concrete_class') }} </p>
                                    <el-form-item class="mb-0" prop="concrete_class">
                                        <el-select name="concreteclass" :disabled="disabled"
                                            v-model="spec1.concrete_class" class="w-full"
                                            :placeholder="$t('concrete_class')" clearable>
                                            <el-option v-for="item in dictionary.concreteclass" :key="item.id"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('brick_brand') }} </p>
                                    <el-form-item class="mb-0" prop="brick_brand">
                                        <el-select name="brick_brand" :disabled="disabled"
                                            v-model="spec1.brick_brand" class="w-full"
                                            :placeholder="$t('brick_brand')" clearable>
                                            <el-option v-for="item in dictionary.brickbrand" :key="item.id"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('armature_class_armatureclass') }} </p>
                                    <el-form-item class="mb-0" prop="armature_class.armatureclass">
                                        <el-select name="armature_class_armatureclass" :disabled="disabled"
                                            v-model="spec1.armature_class.armatureclass" class="w-full"
                                            :placeholder="$t('armature_class_armatureclass')" clearable>
                                            <el-option v-for="item in dictionary.armatureclass" :key="item.id"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('armature_class_armaturediametr') }} </p>
                                    <el-form-item class="mb-0" prop="armature_class.armaturediametr">
                                        <el-select name="armature_class_armaturediametr" :disabled="disabled"
                                            v-model="spec1.armature_class.armaturediametr" class="w-full"
                                            :placeholder="$t('armature_class_armaturediametr')" clearable>
                                            <el-option v-for="item in dictionary.armaturediametr" :key="item.id"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('brick_or_stone_wall_type') }} </p>
                                    <el-form-item class="mb-0" prop="brick_or_stone_wall_type">
                                        <el-select name="brick_or_stone_wall_type" :disabled="disabled"
                                            v-model="spec1.brick_or_stone_wall_type" class="w-full"
                                            :placeholder="$t('brick_or_stone_wall_type')" clearable>
                                            <el-option v-for="item in 3" :key="item.id" :label="item" :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('mixture_class') }} </p>
                                    <el-form-item class="mb-0" prop="mixture_class">
                                        <el-select name="mixture_class" :disabled="disabled"
                                            v-model="spec1.mixture_class" class="w-full"
                                            :placeholder="$t('mixture_class')" clearable>
                                            <el-option v-for="item in dictionary.mixtureClasslist" :key="item.id"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('soil_type') }} </p>
                                    <el-form-item class="mb-0" prop="soil_type">
                                        <el-select name="soil_type" :disabled="disabled"
                                            v-model="spec1.soil_type" class="w-full"
                                            :placeholder="$t('soil_type')" clearable>
                                            <el-option v-for="item in dictionary.soiltype" :key="item.id"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('steel_resistance') }} </p>
                                    <el-form-item class="mb-0" prop="steel_resistance">
                                        <el-input type="number" name="steel_resistance"
                                            :placeholder="$t('steel_resistance')" :disabled="disabled"
                                            v-model="spec1.steel_resistance" />
                                    </el-form-item>
                                </label>
                            </div>
                            <div class="p-1.5 w-full md:w-1/2 lg:w-1/3">
                                <label class="item">
                                    <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('determination_endurance_reserve') }} </p>
                                    <el-form-item class="mb-0" prop="determination_endurance_reserve">
                                        <el-input name="determination_endurance_reserve" type="number"
                                            :placeholder="$t('determination_endurance_reserve')" :disabled="disabled"
                                            v-model="spec1.determination_endurance_reserve" />
                                    </el-form-item>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="-mx-3 sm:mx-0 bg-white p-3 sm:p-4 mt-5" style="border-radius: 20px;">
                        <div class="flex flex-wrap -m-1.5">
                            <div class="p-1.5 w-full lg:w-1/2">
                                <div class="flex flex-wrap -m-1.5">
                                    <div class="p-1.5 w-full sm:w-1/2">
                                        <label class="item">
                                            <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('projection_projecttype') }} </p>
                                            <el-form-item class="mb-0" prop="projection.projecttype">
                                                <el-select name="projection_projecttype" :disabled="disabled"
                                                    v-model="spec1.projection.projecttype"
                                                    :placeholder="$t('projection_projecttype')" class="w-full" clearable>
                                                    <el-option v-for="item in dictionary.projecttype" :key="item.id"
                                                        :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                        :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </label>
                                    </div>
                                    <div v-if="spec1.projection.projecttype === 2" class="p-1.5 w-full sm:w-1/2">
                                        <label class="item">
                                            <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('projection_number') }} </p>
                                            <el-form-item class="mb-0" prop="projection.number">
                                                <el-input name="projection_number" :disabled="disabled"
                                                    :placeholder="$t('projection_number')" type="number"
                                                    v-model="spec1.projection.number" clearable />
                                            </el-form-item>
                                        </label>
                                    </div>
                                    <div class="p-1.5 flex-1">
                                        <label class="item">
                                            <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('project_organization_name') }} </p>
                                            <el-form-item class="mb-0" prop="project_organization_name">
                                                <el-input name="project_organization_name" :disabled="disabled"
                                                    :placeholder="$t('project_organization_name')"
                                                    v-model="spec1.project_organization_name" clearable />
                                            </el-form-item>
                                        </label>
                                    </div>
                                    <div class="p-1.5 w-full">
                                        <label class="item">
                                            <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('seismicity_area') }} </p>
                                            <el-form-item class="mb-0" prop="seismicity_area">
                                                <el-input name="seismicity_area" :disabled="disabled"
                                                    :placeholder="$t('seismicity_area')" v-model="spec1.seismicity_area"
                                                    clearable />
                                            </el-form-item>
                                        </label>
                                    </div>
                                    <div class="p-1.5 w-full">
                                        <label class="item">
                                            <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('construction_installation_works') }} </p>
                                            <el-form-item class="mb-0" prop="construction_installation_works">
                                                <el-input name="construction_installation_works" :disabled="disabled"
                                                    :placeholder="$t('construction_installation_works')"
                                                    v-model="spec1.construction_installation_works" clearable />
                                            </el-form-item>
                                        </label>
                                    </div>
                                    <div class="p-1.5 w-full">
                                        <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('properties') }} </p>
                                        <el-form-item class="mb-0" prop="properties">
                                            <el-select name="properties" :disabled="disabled" v-model="spec1.properties"
                                                class="w-full" :placeholder="$t('properties')" multiple clearable>
                                                <el-option v-for="item in dictionary.properties" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div class="p-1.5 w-full lg:w-1/2">
                                <div class="flex flex-wrap -m-1.5">
                                    <div class="p-1.5 w-full">
                                        <label class="item">
                                            <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('robustness_reliability') }} </p>
                                            <el-form-item class="mb-0" prop="robustness_reliability">
                                                <el-input name="robustness_reliability" :disabled="disabled"
                                                    :placeholder="$t('robustness_reliability')"
                                                    v-model="spec1.robustness_reliability" clearable />
                                            </el-form-item>
                                        </label>
                                    </div>
                                    <div class="p-1.5 w-full">
                                        <label class="item">
                                            <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('dailycondition') }} </p>
                                            <el-form-item class="mb-0" prop="dailycondition">
                                                <el-select name="dailycondition" :disabled="disabled" v-model="spec1.dailycondition"
                                                    class="w-full" :placeholder="$t('dailycondition')" clearable>
                                                    <el-option v-for="item in dictionary.dailycondition" :key="item.id"
                                                        :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                        :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </label>
                                    </div>
                                    <div class="p-1.5 w-full">
                                        <p class="text-slate-800 font-semibold mb-1.5"> {{ $t('communication_engineering') }} </p>
                                        <el-form-item class="mb-0" prop="communication_engineering">
                                            <el-select name="communication_engineering" :disabled="disabled"
                                                v-model="spec1.communication_engineering" class="w-full"
                                                :placeholder="$t('communication_engineering')" clearable multiple>
                                                <el-option v-for="item in dictionary.communicationengineering" :key="item.id"
                                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5">
                        <div class="flex flex-wrap -m-1.5">
                            <div class="p-1.5 w-full lg:w-1/2">
                                <div style="border-radius: 20px;" class="-mx-3 sm:mx-0 bg-white p-3 sm:p-4">
                                    <p class="text-base leading-snug text-slate-800 font-semibold mb-2.5">{{ $t('have_document_file') }}</p>
                                    <label v-if="!disabled" class="relative cursor-pointer flex justify-center items-center p-3 rounded-xl border border-dashed border-slate-300 bg-slate-50" 
                                    :class="errors.file1null ? 'file-error' : ''"
                                        style="box-shadow: 0px 1px 2px 0px #0000000D;"
                                        >
                                        <h-file-upload class="text-slate-300"/>
                                        <div class="text-sm leading-snug ml-2.5">
                                            <p class="text-slate-600"><span class="text-cyan-600 font-bold">Файлни юклаш учун босинг</span> ёки уни олиб шу майдонга ташланг</p>
                                            <p class="text-slate-400">Битта файл ҳажми 30МБ дан ошмаслиги керак!</p>
                                        </div>
                                        <input name="building_type_images" class="hidden" type="file" 
                                            ref="generalconditionfile"
                                            @change="beforeUpload1"
                                            accept=".xlsx,.xls,.jpg,.png,.jpeg,.doc, .docx,.ppt, .pptx,.txt,.pdf" />
                                        <p class="error-p absolute top-full left-0">{{ $t('please_choose_file') }}</p>
                                    </label>
                                    <div v-if="file1List.length" class="mt-5">
                                        <p class="text-sm leading-snug text-slate-500 mb-2.5">{{ $t('uploaded_files') }}</p>
                                        <div class="-m-0.5">
                                            <div v-for="(item, i) in file1List" :key="i" class="p-0.5">
                                                <div class="bg-white border border-slate-200 px-3 py-2 rounded-xl flex items-center gap-2" style="box-shadow: 0px 1px 2px 0px #0000000D;">
                                                    <div>
                                                    <IconFileDoc v-if="item.name.endsWith('.doc') || item.name.endsWith('.docx')"/>
                                                    <icon-file-pdf v-else-if="item.name.endsWith('.pdf')"/>
                                                    <IconFileXls v-else-if="item.name.endsWith('.xls') || item.name.endsWith('.xlsx')"/>
                                                    <IconFileSvg v-else-if="item.name.endsWith('.svg')"/>
                                                    <IconFilePng v-else-if="item.name.endsWith('.png')"/>
                                                    <IconFileJpg v-else-if="item.name.endsWith('.jpg') || item.name.endsWith('.jpeg')"/>
                                                    <IconFile v-else/>
                                                </div>
                                                    <p class="truncate text-slate-950 font-medium leading-snug flex-1">{{item.name}}</p>

                                                    <div class="flex items-center" style="gap: 5px;">
                                                        <a :href="item.file" download target="_blank">
                                                            <button type="button" class="w-10 h-10 rounded-xl flex items-center justify-center bg-indigo-50 text-indigo-800"> <h-file-download/> </button>
                                                        </a>
                                                        <button type="button" v-if="!disabled" class="w-10 h-10 rounded-xl flex items-center justify-center bg-rose-50 text-rose-600" 
                                                        
                                                        @click="beforeRemove1(item, 'generalconditionfile', i)"> <h-trash/></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-1.5 w-full lg:w-1/2">
                                <div style="border-radius: 20px;" class="-mx-3 sm:mx-0 bg-white p-3 sm:p-4">
                                    <p class="text-base leading-snug text-slate-800 font-semibold mb-2.5">{{ $t('have_document_file') }}</p>
                                    <label v-if="!disabled" class="relative cursor-pointer flex justify-center items-center p-3 rounded-xl border border-dashed border-slate-300 bg-slate-50" 
                                    :class="errors.file2null ? 'file-error' : ''"
                                        style="box-shadow: 0px 1px 2px 0px #0000000D;"
                                        >
                                        <h-file-upload class="text-slate-300"/>
                                        <div class="text-sm leading-snug ml-2.5">
                                            <p class="text-slate-600"><span class="text-cyan-600 font-bold">Файлни юклаш учун босинг</span> ёки уни олиб шу майдонга ташланг</p>
                                            <p class="text-slate-400">Битта файл ҳажми 30МБ дан ошмаслиги керак!</p>
                                        </div>
                                        <input name="building_type_images" class="hidden" type="file" 
                                            ref="generalconditionfile"
                                            @change="beforeUpload2"
                                            accept=".xlsx,.xls,.jpg,.png,.jpeg,.doc, .docx,.ppt, .pptx,.txt,.pdf" />
                                        <p class="error-p absolute top-full left-0">{{ $t('please_choose_file') }}</p>
                                    </label>
                                    <div v-if="file2List.length" class="mt-5">
                                        <p class="text-sm leading-snug text-slate-500 mb-2.5">{{ $t('uploaded_files') }}</p>
                                        <div class="-m-0.5">
                                            <div v-for="(item, i) in file2List" :key="i" class="p-0.5">
                                                <div class="bg-white border border-slate-200 px-3 py-2 rounded-xl flex items-center gap-2" style="box-shadow: 0px 1px 2px 0px #0000000D;">
                                                    <div>
                                                    <IconFileDoc v-if="item.name.endsWith('.doc') || item.name.endsWith('.docx')"/>
                                                    <icon-file-pdf v-else-if="item.name.endsWith('.pdf')"/>
                                                    <IconFileXls v-else-if="item.name.endsWith('.xls') || item.name.endsWith('.xlsx')"/>
                                                    <IconFileSvg v-else-if="item.name.endsWith('.svg')"/>
                                                    <IconFilePng v-else-if="item.name.endsWith('.png')"/>
                                                    <IconFileJpg v-else-if="item.name.endsWith('.jpg') || item.name.endsWith('.jpeg')"/>
                                                    <IconFile v-else/>
                                                </div>
                                                <p class="truncate text-slate-950 font-medium leading-snug flex-1">{{item.name}}</p>

                                                    <div class="flex items-center" style="gap: 5px;">
                                                        <a :href="item.file" download target="_blank">
                                                            <button type="button" class="w-10 h-10 rounded-xl flex items-center justify-center bg-indigo-50 text-indigo-800"> <h-file-download/> </button>
                                                        </a>
                                                        <button type="button" v-if="!disabled" class="w-10 h-10 rounded-xl flex items-center justify-center bg-rose-50 text-rose-600" @click="beforeRemove2(item, 'generalconditionfile', i)"> <h-trash/></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!disabled" class="p-2 pl-4 rounded-2xl bg-cool-50 flex flex-wrap gap-2 items-center mt-5">
                    <div class="flex items-center">
                        <h-sertificate class="text-cyan-600 mr-2"/>
                        <h1 class="text-slate-600 text-xl leading-snug font-bold">{{ $t('reconstructionsecondstep_finalconclusion') }} </h1>
                    </div>
                    <div class="flex-1"></div>
                    <label class="item w-full sm:w-auto">
                        <el-form-item class="mb-0 w-full sm:w-96" prop="finalconclusion">
                            <el-select name="reconstructionsecondstep_finalconclusion" :disabled="disabled"
                                v-model="spec1.finalconclusion" class="w-full"
                                :placeholder="$t('reconstructionsecondstep_finalconclusion')" clearable>
                                <el-option v-for="item in dictionary.finalconclusion" :key="item.id"
                                    :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </label>
                </div>
                <div class="mt-5 flex flex-wrap gap-2 items-center justify-between">
                    <button v-if="CurYear >= 30 && 'id' in spec1" type="button" class="rounded-xl bg-indigo-800 text-white flex items-center gap-2 font-semibold leading-snug px-4 py-2"
                        @click="$router.push({ name: 'reconstruction', query: { id: $route.query.id } })">
                        {{ $t('building_last_data') }} <div>
                            <h-file-reload/>
                        </div>
                    </button>
                    <div class="flex-1"></div>
                    <button v-if="role != 'operator' && !disabled" class="add__button" type="button" @click="savespec1()" id="save-button">{{ $t('save') }}
                        <h-check-circle />
                    </button>
                </div>      
            </el-form>
        <div  v-if="modal"  class="modal fs-14" :class="modal?'active':''">
            <div class="modal-cover"></div>
            <div class="modal-item padding-map" style="width:95%; height:95%;">
                <div class="flex justify-between modal-absolute-header">
                    <p class="modal-title "> {{ disabled ? `${$t('show_coor')}:` : `${$t('change_coor')}:` }}</p>
                    <button style="font-size:16px; " @click="modal = false"><i class="el-icon-close"
                            style="font-weight:600;"></i>
                    </button>
                </div>
                <div class="w-full map-item h-full relative">
                    <yandex-map @click="clicked" :coords="coords" style="height: 100%; width: 100%" :zoom="14"
                        :controls="['zoomControl']">
                        <ymap-marker :coords="coords" marker-id="123" hint-content="some hint" />
                        <button v-if="!disabled" @click="findMe" class="absolute bottom-8 right-2 bg-white h-10 w-10 rounded-xl flex items-center justify-center " style="box-shadow: 0 2px 6px 0 rgba(0,0,0,0.2);" type="button">
                            <IconLocation/>
                        </button>
                    </yandex-map>
                </div>
                <div class="flex w-full justify-between modal-bottom fw-w">
                    <div class="flex items-center">
                        <p class="flex items-senter" style="font-size:16px;"><b class="mr-2">{{ $t('coor') }}:</b>
                            {{ coords.join() }} </p>
                    </div>
                    <div class="flex justify-center items-center">
                        <button id="closeMap" @click="modal = false" class="light-button h-10">  {{ $t('close') }}</button>
                        <button id="SaveEditMap" v-if="!disabled" class="ml-2 add__button" type="button"
                            @click="SaveEditMap()"> {{ $t('save') }}</button>
                    </div>
                </div>
            </div>

        </div>
        <el-dialog :title="$t('unattested_reject_warn')" :visible.sync="reject_info.modal" width="400px">
            <div class="w-full">
                <p class="text-sm font-bold mb-0.5">{{ $t('cancel_issue') }}</p>
                <el-input type="textarea" :rows="4" placeholder="..."
                    v-model="reject_info.description"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="reject_info.modal = false">{{ $t('cancel') }}</el-button>
                <el-button type="primary" @click="setStatus('rejected', reject_info.id)">{{ $t('save') }}</el-button>
            </span>
        </el-dialog>
        </div>

    </div>
    <div class="fixed-item" v-else v-loading.fullscreen.lock="loading" :element-loading-text="$t('connecting')"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="fixed-cover"></div>
        <div class="about-knumber">
            <button class="mt-3">
                <iconInfo />
            </button>
            <button class="mt-3">
                <iconQuestion />
            </button>
        </div>
        <div class="pr bg-white rounded-2xl border border-slate-200 p-4 sm:p-7 max-w-full mx-2" style="width: 650px; box-shadow: 0px 4px 15px 0px #0000001A;">
            <p class="text-2xl leading-snug text-slate-950 font-bold mb-5">{{ $t('add_building') }}</p>
            <div class="pb-1.5">
                <span class="font-semibold text-base leading-snug text-slate-800">
                {{ $t("cadaster_number") }}
                </span>
            </div>
            <div class="pb-5">
                <div class="flex items-center gap-2">
                    <el-input
                        name="cadastral_number"
                        class="k-input select_prefix"
                        :class="knumber == 1 || knumber == 5 || knumber == 8 || knumber == 2 ? 'error' : knumber == 3 ? 'connecting' : knumber == 4 ? 'succes' : ''"
                        v-model="spec1.cadastral_number"
                        placeholder="Мисол: 10:01:01:01:01:1111"
                        clearable
                        @keyup.enter.native="CheckKadastor()"
                    >
                        <template slot="prefix">
                            <div class="h-full flex items-center">
                                <icon-number class="text-slate-400 mb-0.5"/>
                            </div>
                        </template>
                    </el-input>
                    <button class="rounded-xl bg-indigo-800 text-white flex items-center gap-2 font-semibold leading-snug  px-2 sm:px-4 py-2" 
                        @click="CheckKadastor()">
                        <span class="hidden sm:inline-block">
                  {{ $t("search_btn") }}
                </span>
                        <HSearch/>
                    </button>
                </div>
                <p v-if="knumber == 1" class="text-sm leading-snug text-rose-600 mt-1.5">
                    {{ $t('uncomplate_cadaster_number') }}</p>
                <p v-if="knumber == 2" class="text-sm leading-snug text-rose-600 mt-1.5">
                    {{ $t('noregister_cadaster_number') }}</p>
                <p v-if="knumber == 9" class="text-sm leading-snug text-rose-600 mt-1.5">
                    {{ $t('none_object_building') }} </p>
                <p v-if="knumber == 8" class="text-sm leading-snug text-rose-600 mt-1.5">
                    {{ $t('error_with_cadaster_server') }} </p>
                <p v-if="knumber == 5" class="text-sm leading-snug text-rose-600 mt-1.5">
                    {{ $t('cadaster_number_have_in') }}</p>
                <p v-if="knumber == 7" class="text-sm leading-snug text-rose-600 mt-1.5">
                    {{ $t('error_with_server') }} </p>
                <p v-if="knumber == 3" class="text-sm leading-snug text-green-400 mt-1.5">
                    {{ $t('cadaster_find_uncomplate_data') }}</p>
                <p v-if="knumber == 4" class="text-sm leading-snug text-green-400 mt-1.5">
                    {{ $t('cadaster_number_find_succes') }}</p>
            </div>
            <div class="erorrsk" v-if="knumber == 2">
                <HWarningError class="w-10 h-10"/>
                <p>{{ $t('no_cadaster_number') }}</p>
            </div>
            <div class="uncompletek" v-if="knumber == 3">
                <HWarningError class="w-10 h-10"/>
                <p>{{ $t('uncomplate_cadaster_data') }}</p>
            </div>
            <div class="succesk" v-if="knumber == 4">
                <HWarningError class="w-10 h-10"/>
                <p>{{ $t('cadaster_number_succes_find') }}</p>
            </div>
            <div class="erorrsk" v-if="knumber == 5">
                <HWarningError class="w-10 h-10"/>
                <p> {{ $t('building_have_server') }} </p>
            </div>
            <div class="erorrsk" v-if="knumber == 7">
                <HWarningError class="w-10 h-10"/>
                <p> {{ $t('error_ser') }}</p>
            </div>
            <div class="erorrsk" v-if="knumber == 8">
                <HWarningError class="w-10 h-10"/>
                <p>{{ $t('error_cadaster_ser') }}</p>
            </div>
            <div class="erorrsk" v-if="knumber == 9">
                <HWarningError class="w-10 h-10"/>
                <p>{{ $t('none_object_for_building') }}</p>
            </div>
            <div class=" flex justify-end">
                <button id="cancel" class="light-button h-10" @click="$router.go(-1)">
                    {{ $t('cancel') }}</button>
                <button id="continue_add" class="add__button ml-2 h-10" v-if="knumber == 3" 
                    @click="knumber = 6"> {{ $t('continue_add') }} <HDirectionRight01/></button>
                <button id="continue_add" class="add__button ml-2 h-10" v-if="knumber == 4" 
                    @click="knumber = 6"> {{ $t('continue_add') }} <HFile01/> </button>
            </div>
        </div>
    </div>
</template>

<script>
import districts from '@/assets/files/districts.json'
import Moment from 'moment';
import InvestmentSwitch from "@/components/InvestmentSwitch";

// ICONS
import iconInfo from './Icons/iconInfo.vue';
import iconQuestion from './Icons/iconQuestion.vue';

import {
    extendMoment
} from 'moment-range';
import HSertificate from './Icons/hSertificate.vue';
import IconBuilding4 from './Icons/iconBuilding4.vue';
import IconInvestment2 from './Icons/iconInvestment2.vue';
import IconInvestment3 from './Icons/iconInvestment3.vue';
import HEye from './Icons/hEye.vue';
import HEdit from './Icons/hEdit.vue';
import HCompass from './Icons/hCompass.vue';
import IconReconstruction from './Icons/iconReconstruction.vue';
import HFileUpload from './Icons/hFileUpload.vue';
import IconFileDoc from './Icons/iconFileDoc.vue';
import IconFilePdf from './Icons/iconFilePdf.vue';
import HFileDownload from './Icons/hFileDownload.vue';
import HTrash from './Icons/hTrash.vue';
import IconFileXls from './Icons/iconFileXls.vue';
import IconFileSvg from './Icons/iconFileSvg.vue';
import IconFilePng from './Icons/iconFilePng.vue';
import IconFileJpg from './Icons/iconFileJpg.vue';
import IconFile from './Icons/iconFile.vue';
import HFileReload from './Icons/hFileReload.vue';
import HCheckCircle from './Icons/hCheckCircle.vue';
import HRemoveCircle from './Icons/hRemoveCircle.vue';
import HReload from './Icons/hReload.vue';
import IconNumber from './Icons/iconNumber.vue';
import HSearch from './Icons/hSearch.vue';
import HWarningError from './Icons/hWarningError.vue';
import HFile01 from './Icons/hFile01.vue';
import HDirectionRight01 from './Icons/hDirectionRight01.vue';
import IconLocation from './Icons/iconLocation.vue';
const moment = extendMoment(Moment);
export default {
    props: {
        geo: '',
        cadastral_number: ''

    },
    components: {
        InvestmentSwitch, iconInfo, iconQuestion, HSertificate, IconBuilding4, IconInvestment2, IconInvestment3, HEye, HEdit, HCompass, IconReconstruction, HFileUpload 
        , IconFileDoc, IconFilePdf, HFileDownload, HTrash, IconFileXls, IconFileSvg, IconFilePng, IconFileJpg, IconFile, HFileReload,
        HCheckCircle,
        HRemoveCircle,
        HReload,
        IconNumber,
        HSearch,
        HWarningError,
        IconLocation,
        HDirectionRight01,
        HFile01
    },
    data() {
        return {
            visibleApprove: false,
            visibleReject: false,
            visibleNew: false,
            knumber: 0,
            a: '',
            error: {},
            pickerOptions: {
                disabledDate(date) {
                    return date < new Date('2021');
                },
            },
            objInfo: {},
            loading: false,
            disabled: false,
            CurYear: 0,
            generalinformation: {},
            errors: {
                generalinformation: false,
                cadastral_number: false,
                region: false,
                district: false,
                address: false,
                year_construction: false,
                numberfloors: false,
                building_group: false,
                neighborhood: false,
                neighborhood_id: false,
                file1null: false,
                file2null: false
            },
            spec1: {
                generalinformation: this.$route.params.id,
                cadastral_number: this.cadastral_number,
                name_uz: "",
                name_ru: "",
                name_cyr: "",
                region: null,
                district: null,
                building_group: null,
                neighborhood: '',
                neighborhood_id: null,
                address: "",
                year_construction: null,
                buildingseismicity: null,
                geolocation: null,
                numberfloors: null,
                constructivesolution: null,
                plannedshape: null,
                overall_size: {
                    length: null,
                    width: null,
                    height: null,
                    unit: 1,
                },
                floors_height: {
                    value: null,
                    unit: 1,
                },
                part_attic: {
                    value: null,
                    unit: 1,
                },
                technical_height: {
                    value: null,
                    unit: 1,
                },
                basement_presence: {
                    length: null,
                    height: null,
                    width: null,
                    presence: null,
                    unit: 1,
                },
                divided_into_sections: null,
                balance_value: {
                    price: "",
                    currency: 1,
                },
                foundation_type: null,
                load_bearing: null,
                coverings: null,
                roofsection: null,
                divisions_number: null,
                section_parameters: {
                    length: null,
                    width: null,
                    height: null,
                    unit: 1,
                },
                transverse_wall_step: null,
                longitudinal_wall: null,
                longitudinal_wall_spacing: null,
                seismicbelts: null,
                connectingbelts: null,
                window_spacing: {
                    length: null,
                    width: null,
                    height: null,
                    unit: 1,
                },
                curtains: {
                    length: null,
                    width: null,
                    height: null,
                    unit: 1,
                },
                concrete_class: null,
                brick_brand: null,
                mixture_class: null,
                soil_type: null,
                armature_class: {
                    armatureclass: null,
                    armaturediametr: null,
                },
                steel_resistance: "",
                brick_or_stone_wall_type: "",
                determination_endurance_reserve: "",
                projection: {
                    number: null,
                    projecttype: null,
                },
                project_organization_name: "",
                construction_installation_works: "",
                properties: [],
                seismicity_area: "",
                communication_engineering: [],
                robustness_reliability: "",
                dailycondition: null,
                finalconclusion: null,
            },
            rules1: {
                cadastral_number: [{
                    required: true,
                    message: this.$t('please_add_cadastrel_number'),
                    trigger: "change",
                },
                    // { min: 3, max: 5, message: 'Кадастр рақами ', trigger: 'blur' }
                ],
                name_cyr: [{
                    required: true,
                    message: this.$t('please_add_building_name'),
                    trigger: "change",
                },],
                region: [{
                    required: true,
                    message: this.$t('choose_region'),
                    trigger: "change"
                },],
                district: [{
                    required: true,
                    message: this.$t('choose_district'),
                    trigger: "change",
                },],
                address: [{
                    required: true,
                    message: this.$t('choose_adress'),
                    trigger: "change",
                },],
                numberfloors: [{
                    required: true,
                    message: this.$t('choose_numberfloors'),
                    trigger: "change",
                },],
                building_group: [{
                    required: true,
                    message: this.$t('choose_building_group'),
                    trigger: "change"
                },],
                year_construction: [{
                    required: true,
                    message: this.$t('choose_year_construction'),
                    trigger: "change",
                },],

                geolocation: [{
                    required: true,
                    message: this.$t('choose_geolocation'),
                    trigger: "change",
                },],
                floors_height: {
                    value: [{
                        required: true,
                        message: this.$t('choose_floors_height_value'),
                        trigger: "change",
                    },],
                    unit: [{
                        required: true,
                        message: this.$t('choose_unit'),
                        trigger: "change",
                    },],
                },
                constructivesolution: [{
                    required: true,
                    message: this.$t('choose_constructivesolution'),
                    trigger: "change",
                },
                    // { min: 3, max: 5, message: 'Кадастр рақами ', trigger: 'blur' }
                ],
                buildingseismicity: [{
                    required: true,
                    message: this.$t('choose_buildingseismicity'),
                    trigger: "change"
                },],
                plannedshape: [{
                    required: true,
                    message: this.$t('choose_plannedshape'),
                    trigger: "change",
                },],
                numberfloors: [{
                    required: true,
                    message: this.$t('choose_numberfloors'),
                    trigger: "change",
                },],
                overall_size: {
                    length: [{
                        required: true,
                        message: this.$t('choose_overall_size_length'),
                        trigger: "change",
                    },],
                    width: [{
                        required: true,
                        message: this.$t('choose_overall_size_width'),
                        trigger: "change",
                    },],
                    height: [{
                        required: true,
                        message: this.$t('choose_overall_size_height'),
                        trigger: "change",
                    },],
                    unit: [{
                        required: true,
                        message: this.$t('choose_unit'),
                        trigger: "change",
                    },],
                },
                floors_height: {
                    value: [{
                        required: true,
                        message: this.$t('file_secsess_send'),
                        trigger: "change",
                    },],
                    unit: [{
                        required: true,
                        message: this.$t('choose_unit'),
                        trigger: "change",
                    },],
                },
                part_attic: {
                    value: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                    unit: [{
                        required: true,
                        message: this.$t('choose_unit'),
                        trigger: "change",
                    },],
                },
                technical_height: {
                    value: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                    unit: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                },
                basement_presence: {
                    presence: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                },
                divided_into_sections: [{
                    required: true,
                    message: this.$t('choose_divided_into_sections'),
                    trigger: "change",
                },],
                balance_value: {
                    price: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                    currency: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                },
                foundation_type: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                load_bearing: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                coverings: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change"
                },],
                roofsection: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change"
                },],
                divisions_number: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },
                    // { min: 3, max: 5, message: 'Кадастр рақами ', trigger: 'blur' }
                ],
                section_parameters: {
                    length: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    },],
                    width: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    }],
                    height: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    }],
                    unit: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                },
                transverse_wall_step: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                longitudinal_wall: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                longitudinal_wall_spacing: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                seismicbelts: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                connectingbelts: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                window_spacing: {
                    length: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    },],
                    width: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    }],
                    height: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    }],
                    unit: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                },
                curtains: {
                    length: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    },],
                    width: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    }],
                    height: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    }],
                    unit: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                },
                concrete_class: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change"
                },
                    // { min: 3, max: 5, message: 'Кадастр рақами ', trigger: 'blur' }
                ],
                brick_brand: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                mixture_class: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                soil_type: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                armature_class: {
                    armatureclass: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                    armaturediametr: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    },],
                },
                steel_resistance: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                brick_or_stone_wall_type: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                determination_endurance_reserve: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                projection: {
                    number: [{
                        message: this.$t('please_enter_data'),
                        trigger: "change"
                    },],
                    projecttype: [{
                        required: true,
                        message: this.$t('please_enter_data'),
                        trigger: "change",
                    },],
                },
                project_organization_name: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                construction_installation_works: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                properties: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                seismicity_area: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                communication_engineering: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                robustness_reliability: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
                dailycondition: [{
                    required: true,
                    message: this.$t('choose_dailycondition'),
                    trigger: "change",
                },],
                finalconclusion: [{
                    required: true,
                    message: this.$t('please_enter_data'),
                    trigger: "change",
                },],
            },
            current_district: [],
            obj: {},
            file1List: [],
            file2List: [],
            files1: [],
            files2: [],
            activeNames: '1',
            coords: [41.31629324503914, 69.26717199864542],
            coor: null,
            modal: false,
            textarea1: null,
            value: null,
            value1: null,
            value3: null,
            loading: false,
            file1Name: null,
            file2Name: null,
            districts: districts,
            disableds: [false, true, true, true, true],
            reject_info: {
                modal: false,
                id: '',
                action: '',
                description: ''
            }
        };
    },
    computed: {
        isCreated() {
            return !!this.$route.query.id;
        },
        file1Url() {
            return axios.defaults.baseURL + "dictionary/filetechnicaldoc/";
        },
        file2Url() {
            return axios.defaults.baseURL + "dictionary/deedfile/";
        },
        role() {
            let a = this.$store.state.role;
            // if (a == 'operator') {
            //     this.disabled = true;
            // }
            if (a == 'admin') {
                this.disableds = [false, false, false, false, false]
            }

            return a
        },
        dictionary() {
            return this.$store.state.dictionary;
        },
        activer() {
            return this.$store.state.activeName
        },
        disabletItem() {
            return this.$store.state.disabletItem
        },
        units() {
            return this.$store.state.units;
        },
    },
    watch: {
        cadastral_number() {
            this.spec1.cadastral_number = this.cadastral_number
        },
        file1List() {
            if (this.file1List.length > 0) {
                this.errors.file1null = false
            }
        },
        file2List() {
            if (this.file2List.length > 0) {
                this.errors.file2null = false
            }
        }

    },
    mounted() {
        this.activeNames = this.activer
        if (this.$route.params.edit == '0' || this.role === 'supervisor') {
            this.disabled = true
        } else {
            this.disabled = false
        }

        // if (this.role == 'admin') {
        //     this.disabled = true
        // }
        if (this.disabled) {
            this.activeNames = ['1']
        }
        this.$store.commit('set_activename', ['1'])
        this.__GET();

        if (this.$route.query.id) {
            this.knumber = 6
        }
    },
    methods: {
        downloadFile(file) {
            const link = document.createElement('a');
            link.href = file;
            const fileName = file.split('/').pop() || 'download';
            link.download = fileName;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        findMe() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                position => {
                    this.coords = [position.coords.latitude, position.coords.longitude]
                    this.zoom = 14
                },
                error => {
                    console.error('Joylashuv aniqlanmadi:', error.message)
                    alert('Joylashuvingizni aniqlash uchun ruxsat bering!')
                }
                )
            } else {
                alert('Sizning brauzeringiz geolokatsiyani qo‘llamaydi 😕')
            }
        },
        setStatus(action, id) {
            let data = {
                id: id,
                status: action === 'approved' ? 'approved' : 'rejected'
            };
            if (action === 'approved') {
                this.$notify({
                    title: this.$t('approve_n'),
                    type: 'success'
                });
            } else if (action === 'rejected') {
                this.$notify.info({
                    title: this.$t('unattested_rejected_n'),
                });
                data.description = this.reject_info.description
            }



            axios.patch(`/building/status/`, data);
            this.$router.go(-2);
            this.visibleApprove = false;
            this.visibleReject = false;
        },
        setStatusToNew(id) {
            axios.patch("/building/specificationlist/bulk-status/", {
                objects: [id],
                status: 'new'
            }).then(() => {
                this.$notify({
                    title: this.$t('status_set_new'),
                    type: 'success'
                });
                this.$router.go(-2);
            }).catch(() => {
                this.$notify.error({
                    title: this.$t('status_set_error'),
                });
            });
        },
        __GET() {
            if (this.isCreated) {
                this.loading = true;
                if (this.$route.query.id) {
                    axios.get(`/building/specification/${this.$route.query.id}/`)
                        .then((response) => {
                            this.spec1 = response.data;
                            if (this.spec1.overall_size == null) {
                                this.spec1.overall_size = {
                                    length: null,
                                    width: null,
                                    height: null,
                                    unit: 1,
                                }
                            }
                            if (this.spec1.floors_height == null) {
                                this.spec1.floors_height = {
                                    value: null,
                                    unit: 1,
                                }
                            }
                            if (this.spec1.part_attic == null) {
                                this.spec1.part_attic = {
                                    value: null,
                                    unit: 1,
                                }
                            }
                            if (this.spec1.technical_height == null) {
                                this.spec1.technical_height = {
                                    value: null,
                                    unit: 1,
                                }
                            }
                            if (this.spec1.basement_presence == null) {
                                this.spec1.basement_presence = {
                                    length: null,
                                    height: null,
                                    width: null,
                                    presence: null,
                                    unit: 1,
                                }
                            }
                            if (this.spec1.balance_value == null) {
                                this.spec1.balance_value = {
                                    price: "",
                                    currency: 1,
                                }
                            }
                            if (this.spec1.section_parameters == null) {
                                this.spec1.section_parameters = {
                                    length: null,
                                    width: null,
                                    height: null,
                                    unit: 1,
                                }
                            }
                            if (this.spec1.window_spacing == null) {
                                this.spec1.window_spacing = {
                                    length: null,
                                    width: null,
                                    height: null,
                                    unit: 1,
                                }
                            }
                            if (this.spec1.curtains == null) {
                                this.spec1.curtains = {
                                    length: null,
                                    width: null,
                                    height: null,
                                    unit: 1,
                                }
                            }
                            if (this.spec1.armature_class == null) {
                                this.spec1.armature_class = {
                                    armatureclass: null,
                                    armaturediametr: null,
                                }
                            }
                            if (this.spec1.projection == null) {
                                this.spec1.projection = {
                                    number: null,
                                    projecttype: null,
                                }
                            }
                            this.coor = response.data.geolocation.join();
                            this.CurrentYear(response.data.created_at);
                            this.spec1.year_construction = String(
                                response.data.year_construction
                            );
                        })
                        .finally(() => {
                            this.loading = false
                        })
                    this.getFiles();
                }
            }
        },
        CurrentYear(a) {
            a = a.split(".")

            a = a[2] + "-" + a[1] + "-" + a[0]
            var b = new Date()
            b = b.getFullYear() + "-" + String(b.getMonth() + 1).padStart(2, '0') + "-" + String(b.getDate()).padStart(2, '0');;
            const start = moment(a);
            const end = moment(b);
            const range = moment.range(start, end);
            this.CurYear = parseInt(range.diff('days'));
        },
        getFiles(val) {
            if (val === 1) {
                axios
                    .get(
                        `/dictionary/filetechnicaldoclist/?technical_document_file=${this.$route.query.id}`
                    )
                    .then((response) => {
                        this.file1List = response.data;
                    });
            } else if (val === 2) {
                axios
                    .get(`/dictionary/deedfilelist/?deed_file=${this.$route.query.id}`)
                    .then((response) => {
                        this.file2List = response.data;
                    });
            } else {
                axios
                    .get(
                        `/dictionary/filetechnicaldoclist/?technical_document_file=${this.$route.query.id}`
                    )
                    .then((response) => {
                        this.file1List = response.data;
                    });
                axios
                    .get(`/dictionary/deedfilelist/?deed_file=${this.$route.query.id}`)
                    .then((response) => {
                        this.file2List = response.data;
                    });
            }
        },
        beforeUpload1(event) {
            var file = event?.target?.files[0] || event
            if (this.$route.query.id && this.$route.query.id != undefined) {
                let formData = new FormData();
                formData.append("name", file.name);
                formData.append("file", file);
                formData.append("technical_document_file", this.$route.query.id);
                axios.post(this.file1Url, formData).then((response) => {
                    this.$swal.fire({
                        icon: 'success',
                        title: this.$t('file_secsess_send'),
                        timer: 3000
                    })
                    this.getFiles(1);
                });
            } else {
                this.file1List.push({
                    name: file.name,
                    file: file
                })
                this.files1.push({
                    name: file.name,
                    file: file
                })
            }
        },
        beforeUpload2(event) {
            var file = event?.target?.files[0] || event
            if (this.$route.query.id && this.$route.query.id != undefined) {
                let formData = new FormData();
                formData.append("name", file.name);
                formData.append("file", file);
                formData.append("deed_file", this.$route.query.id);
                axios.post(this.file2Url, formData).then((response) => {
                    this.$swal.fire({
                        icon: 'success',
                        title: this.$t('file_secsess_send'),
                        timer: 3000
                    })
                    this.getFiles(2);
                });
            } else {
                this.file2List.push({
                    name: file.name,
                    file: file
                })
                this.files2.push({
                    name: file.name,
                    file: file
                })
            }
        },
        uploadFile(files, i, id, link, link_name) {
            if (i < files.length && i != files.length) {
                let formData = new FormData();
                formData.append('name', files[i].name)
                formData.append('file', files[i].file)
                formData.append(link_name, id)
                axios.post(link, formData)
                    .then((response) => {
                        // this.getFiles(link);
                    })
                i = i + 1;
                this.uploadFile(files, i, id, link, link_name)
            } else {
                return 0
            }

        },
        savespec1() {
            this.$refs.spec1.validate((valid) => {
                if (typeof this.spec1.geolocation == 'string') {
                    this.spec1.geolocation = this.spec1.geolocation.split(",")
                }
                if (valid && this.file1List.length > 0 && this.file2List.length > 0) {
                    if (this.$route.query.id && this.$route.query.id != undefined) {
                        this.loading = true;
                        axios.patch(`/building/specification/update/${this.$route.query.id}/`, this.spec1)
                            .then((response) => {
                                this.__GET();
                                this.$swal.fire({
                                    icon: 'success',
                                    title: this.$t('data_saved'),
                                    timer: 3000
                                })
                                    .then(() => {
                                        if (this.$route.params.obj) {
                                            this.$router.push({
                                                path: `/objects/building-list/${this.$route.params.obj}`
                                            })
                                        } else {
                                            this.$router.push({
                                                path: `/building-list/new`
                                            })
                                        }
                                    })

                            })
                            .catch((error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: this.$t('error_save'),
                                    timer: 3000
                                })
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    } else {
                        this.loading = true;
                        axios.post(`/building/specification/`, this.spec1)
                            .then((response) => {

                                this.__GET();
                                this.uploadFile(this.files1, 0, response.data.id, this.file1Url, 'technical_document_file')
                                this.uploadFile(this.files2, 0, response.data.id, this.file2Url, 'deed_file')
                                this.$swal.fire({
                                    icon: 'success',
                                    title: this.$t('data_saved'),
                                    timer: 3000
                                })
                                    .then(() => {
                                        if (this.$route.params.obj) {
                                            this.$router.push({
                                                path: `/objects/building-list/${this.$route.params.obj}`
                                            })
                                        } else {
                                            this.$router.push({
                                                path: `/building-list/new`
                                            })
                                        }
                                    })

                            })
                            .catch((error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: this.$t('error_save'),
                                    timer: 3000
                                })
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }

                } else {
                    if (this.file1List.length == 0) {
                        this.errors.file1null = true
                    }
                    if (this.file2List.length == 0) {
                        this.errors.file2null = true
                    }
                }
            })
        },
        regionChanged() {
            this.current_district = [];
            this.spec1.district = [];
        },
        handlePreview(file) {
            // window.open(file.file)
            const url = file.file
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', "a")
            document.body.appendChild(link)
            link.click()
        },
        beforeRemove1(file, fileList) {
            if (this.$route.query.id && this.$route.query.id != undefined) {
                return this.$confirm(`${this.$t('do_delete_file')} ${file.name} ?`).then(
                    () => {
                        axios
                            .delete(`/dictionary/filetechnicaldocdestroy/${file.id}/`)
                            .then((response) => {
                                this.$swal.fire({
                                    icon: 'success',
                                    title: this.$t('file_secsess_send'),
                                    timer: 3000
                                })
                                this.getFiles()
                            })
                            .catch((error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: this.$t('error_delete_file'),
                                    timer: 3000
                                });
                            });
                    }
                );
            }
            else {
                var index = -1
                for (let i = 0; i < this.file1List.length; i++) {
                    if (this.file1List[i].name == file.name) {
                        index = i
                    }
                }
                if (index != -1) {
                    this.file1List.splice(index, 1);
                    this.files1.splice(index, 1);
                }
            }
        },
        beforeRemove2(file, fileList) {
            if (this.$route.query.id && this.$route.query.id != undefined) {
                return this.$confirm(`${this.$t('do_delete_file')} ${file.name} ?`).then(
                    () => {
                        axios
                            .delete(`/dictionary/deedfiledestroy/${file.id}/`)
                            .then((response) => {
                                this.$swal.fire({
                                    icon: 'success',
                                    title: this.$t('file_secsess_send'),
                                    timer: 3000
                                })
                                this.getFiles()
                            })
                            .catch((error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: this.$t('error_delete_file'),
                                    timer: 3000
                                });
                            });
                    }
                );
            }
            else {
                var index = -1
                for (let i = 0; i < this.file2List.length; i++) {
                    if (this.file2List[i].name == file.name) {
                        index = i
                    }
                }
                if (index != -1) {
                    this.file2List.splice(index, 1);
                    this.files2.splice(index, 1);
                }
            }
        },
        CheckKadastor() {
            if (this.spec1.cadastral_number.length == 0) {
                this.knumber = 0
            }
            else if (this.spec1.cadastral_number.length < 15) {
                this.knumber = 1
            }
            else {
                this.loading = true
                var data = {
                    type: "building",
                    cad_num: this.spec1.cadastral_number
                }
                this.erors = []
                axios.get(`/building/cadastral/${this.spec1.cadastral_number}/`)
                    .then(res => {
                        this.a = res.data
                        if (res.data.result || res.data.object == null) {
                            this.loading = false
                            if (!res.data.object && res.data.result == 0) {
                                this.knumber = 9
                            } else {
                                this.knumber = 5
                            }

                        } else {
                            axios.get(`/building/generalinformation/${res.data.object}/`)
                                .then((response) => {
                                    this.generalinformation = response.data
                                });
                            this.spec1.generalinformation = res.data.object
                            axios.post('/dictionary/insert/cadastr/', data)
                                .then((res) => {
                                    if (res.data.result == 0) {
                                        this.knumber = 2
                                        this.loading = false
                                        this.error.message = res.data.message
                                    } else {

                                        if (res.data.outer || res.data.objects) {
                                            var b = res.data.outer.filter((item) => {
                                                return item.cad_end === this.spec1.cadastral_number
                                            })
                                            if (!b.length) {
                                                b = res.data.objects.filter((item) => {
                                                    return item.cadastral_number_object === this.spec1.cadastral_number
                                                })  
                                            }
                                            if (b.length > 0) {
                                                // name

                                                // Street
                                                if (res.data.address) {
                                                    var address = res.data.address.split(",")
                                                    if (address.length > 3) {
                                                        this.spec1.address = address[2] + address[3]
                                                    }
                                                    if (address.length > 1) {
                                                        this.spec1.address = address[0] + address[1]
                                                    } else {
                                                        address = res.data.address.split(".")
                                                        if (address.length > 2) {
                                                            this.spec1.address = address[2]
                                                        } else {
                                                            this.spec1.address = res.data.address
                                                        }
                                                    }
                                                    this.errors.adress = false

                                                } else {
                                                    this.errors.adress = true
                                                }
                                                // Region
                                                this.spec1.region = res.data.region_id
                                                // District
                                                axios.get(`/dictionary/district/?region__shared_id=${this.spec1.region}`)
                                                    .then((response) => {
                                                        this.current_district = response.data;
                                                        this.spec1.district = res.data.district_id
                                                    })
                                                // Neighboard
                                                if (res.data.neighborhood) {
                                                    this.spec1.neighborhood = res.data.neighborhood
                                                    this.erors.neighborhood = false

                                                } else {
                                                    this.erors.neighborhood = true
                                                }
                                                if (res.data.neighborhood_id) {
                                                    this.spec1.neighborhood_id = res.data.neighborhood_id
                                                    this.erors.neighborhood_id = false
                                                } else {
                                                    this.erors.neighborhood_id = true
                                                }
                                                // numberfloors
                                                if (b[0].numberfloors) {
                                                    this.spec1.numberfloors = parseInt(b[0].numberfloors)
                                                    this.erors.numberfloors = false

                                                } else {
                                                    this.erors.numberfloors = true
                                                }

                                                // date building
                                                if (res.data.year) {
                                                    var date = res.data.year.split(".")
                                                    if (date.length > 1) {
                                                        this.spec1.year_construction = date[2]
                                                    } else {
                                                        date = res.data.year.split("-")
                                                        this.spec1.year_construction = date[0]
                                                    }
                                                    this.errors.year_construction = true
                                                } else {
                                                    this.errors.year_construction = false
                                                }
                                                this.knumber = 4
                                                if (!this.errors.year_construction) {
                                                    this.knumber = 3
                                                }
                                                this.loading = false
                                            } else {
                                                this.knumber = 2
                                                this.loading = false
                                                if (res.data.message) {
                                                    this.errors.message = res.data.message
                                                }

                                            }
                                        } else {
                                            this.knumber = 2
                                            this.loading = false
                                            if (res.data.message) {
                                                this.errors.message = res.data.message
                                            }
                                        }

                                    }

                                })
                                .catch(e => {
                                    this.loading = false
                                    this.knumber = 8
                                })
                        }

                    })
                    .catch(e => {
                        this.knumber = 7
                        this.loading = false
                    })

            }

        },
        GetGeneralInfo(id) {
            axios
                .get(`/building/generalinformation/${id}/`)
                .then((response) => {
                    this.generalinformation = response.data;
                    this.coords = response.data.geolocation;

                });
        },
        EditMap(id) {
            this.modal = true
            if (this.coor) {
                this.coords = this.coor.split(',')
            } else {

                this.coords = this.districts[`${id}`] && this.districts[`${id}`].coor ? this.districts[`${id}`].coor : [41.31629324503914, 69.26717199864542]
            }

        },
        SaveEditMap() {
            this.modal = false
            this.coor = this.coords.join()
            this.spec1.geolocation = this.coords;
        },
        clicked(e) {
            if (!this.disabled) {
                this.coords = e.get("coords");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.finalconclusion_1{
    background: #10B981;
}
.finalconclusion_2{
    background: #84CC16;
}
.finalconclusion_3{
    background: #F59E0B;
}
.finalconclusion_4{
    background: #EF4444;
}
.file-error {
    color: red;
}

.error-p {
    display: none;
}

.file-error .error-p {
    color: red;
    font-size: 14px;
    margin-top: 5px;
    display: block !important;
}

.Form {
    .el-form-item__content {
        margin-left: 0 !important;
    }
}

.el-upload-list__item {
    transition: none;
}
</style>
